import api from "../config/connection";

class Service {

    static myInstance = null;

    static getInstance(){
        if(Service.myInstance == null){
            Service.myInstance = new Service();
        }
        return this.myInstance;
    }

    get(url){
        return api.get(url);
    }

    async post(url, objeto){
        const response = await api.post(url, objeto);
        return response;
    }

    async patch(url, objeto){
        return api.patch(url, objeto);
    }

    async put(url, objeto){
        return api.put(url, objeto);
    }

    async delete(url, objeto){
        const resp = await api.delete(url, objeto);
        return resp;
    }

    async upload(url, formData, config) {
        const resp = await api.post(url, formData, config);
        return resp;
    }

    async download(url) {
        const resp = await api.get(url, { responseType: 'blob' });
        return resp;
    }

    // Nova fun��o para baixar PDF da secretaria
    async downloadSecretariaPDF(hashid) {
        const resp = await api.get(`publica/secretaria/${hashid}/pdf/download`, {
            responseType: 'blob'
        });
        return resp;
    }

    // Nova fun��o para visualizar PDF da secretaria (retorna blob para abrir em nova aba)
    async viewSecretariaPDF(hashid) {
        const resp = await api.get(`publica/secretaria/${hashid}/pdf/view`, {
            responseType: 'blob'
        });
        return resp;
    }

}

export default Service;
